<script lang="ts">
  /**
   * MySetCardImage — a saved set, drawn as the share card itself.
   *
   * No new card style: this is share-card's own renderer (C4,
   * `renderShareCardSvg`, the "link" 1200x630 layout, the same drawing the
   * friend's link preview and the Share sheet use), shown as an SVG data: URL.
   * A ShareSet carries blocks, not laps, so the lap-level set components
   * (SetGroupRibbon, SetRibbon) cannot draw it; the card renderer is the one
   * component in the app whose input IS a ShareSet. SVG, not the PNG path: it
   * needs no 2D canvas, stays sharp at any width, and draws synchronously.
   * Every string on the card is escaped and capped by the renderer (C1).
   */
  import { renderShareCardSvg, svgDataUrl } from "../shareCard/render";
  import type { ShareSetCard } from "../shareCard/types";

  let { card }: { card: ShareSetCard } = $props();

  let src = $derived(svgDataUrl(renderShareCardSvg(card, "link")));
  let alt = $derived(
    `${card.set.name}${card.owner ? `, from ${card.owner}` : ""}: ` +
      card.set.blocks.map((b) => `${b.label} ${b.stroke}`).join(", "),
  );
</script>

<img class="set-card-image" {src} {alt} width="1200" height="630" />

<style>
  .set-card-image {
    display: block;
    width: 100%;
    height: auto;
    aspect-ratio: 1200 / 630;
    border-radius: var(--radius-button);
    border: 1px solid var(--divider);
  }
</style>
